import React from "react";

import { MdmObjectDto } from "gql/generated/types";
import { Link } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { TableColumn } from "../utils/types";
import ItemsTable from "./ItemsTable";

type ObjectNodesProps = {
  object: MdmObjectDto;
};

const ObjectNodes: React.FC<ObjectNodesProps> = ({ object }) => {
  const renderActions = (rowData: MdmObjectDto) => (
    <Link to={`../nodes/${rowData.id}`}>{rowData.identifier}</Link>
  );

  const columns: TableColumn<MdmObjectDto>[] = [
    {
      field: "identifier",
      header: T("mdm.apartment-code"),
      body: renderActions,
      sortable: true,
      columnKey: "identifier",
    },
    {
      field: "title",
      header: T("word.object-name"),
      sortable: true,
      columnKey: "objectName",
    },
    {
      field: "address.fullAddress",
      header: T("word.address"),
      sortable: true,
      columnKey: "address",
    },
    {
      field: "address.houseNumber",
      header: T("word.house-number"),
      sortable: true,
      columnKey: "houseNumber",
    },
  ];

  return (
    <ItemsTable
      columns={columns}
      tableName="NodesByObject"
      data={(object.children as MdmObjectDto[]) ?? []}
      searchFields={["identifier", "title"]}
      showToolbarBtn={false}
    />
  );
};

export default ObjectNodes;
